// 财务报表模板
export default {
  tableHeaderList: state => state.financReportFormsTemplate.tableHeaderList,
  tableDataList: state => state.financReportFormsTemplate.financReportFormsTemplate,
}